import axios from 'axios';
import { toast } from 'react-toastify';

// Helper: push a compact entry to the global API trail (last 10)
function pushApiTrail(entry) {
  try {
    window.__API_TRAIL = window.__API_TRAIL || [];
    window.__API_TRAIL.push({ ts: Date.now(), ...entry });
    if (window.__API_TRAIL.length > 10) window.__API_TRAIL.shift();
  } catch (_) {}
}

// Attach interceptors (request/response) to an axios instance
function attachInterceptors(instance) {
  // Request: timestamp + id
  instance.interceptors.request.use((config) => {
    try {
      config.__requestId = Math.random().toString(36).slice(2);
      config.metadata = { start: (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now() };
    } catch (_) {}
    return config;
  }, (error) => Promise.reject(error));

  // Response OK
  instance.interceptors.response.use((response) => {
    try {
      const cfg = response?.config || {};
      const start = cfg?.metadata?.start || Date.now();
      const end = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();
      const durationMs = Math.max(0, Math.round(end - start));
      const base = cfg.baseURL || '';
      let fullUrl = cfg.url || '';
      try {
        fullUrl = new URL(cfg.url || '', base || window.location.origin).toString();
      } catch (_) {}
      pushApiTrail({ id: cfg.__requestId, ok: true, method: (cfg.method || 'get').toUpperCase(), url: fullUrl, status: response.status, durationMs });
    } catch (_) {}
    return response;
  }, (error) => {
    try {
      const cfg = error?.config || {};
      const start = cfg?.metadata?.start || Date.now();
      const end = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();
      const durationMs = Math.max(0, Math.round(end - start));
      const base = cfg.baseURL || '';
      let fullUrl = cfg.url || '';
      try {
        fullUrl = new URL(cfg.url || '', base || window.location.origin).toString();
      } catch (_) {}
      const status = error?.response?.status || null;
      // Toast para 429 (rate limit)
      if (status === 429) {
        toast.error('Demasiadas solicitudes. Por favor, intente de nuevo más tarde.');
      }
      pushApiTrail({ id: cfg.__requestId, ok: false, method: (cfg.method || 'get').toUpperCase(), url: fullUrl, status, durationMs, message: error?.message });
    } catch (_) {}
    return Promise.reject(error);
  });
}

// Monkey-patch axios.create para aplicar interceptores a cada instancia
const originalCreate = axios.create;
axios.create = function(config) {
  const instance = originalCreate(config);
  attachInterceptors(instance);
  return instance;
};

// Asegurar interceptores también en la instancia por defecto
attachInterceptors(axios);

export const getBaseUrl = () => {
  if (window.location.hostname === 'localhost') {
    const port = process.env.REACT_APP_API_PORT || 8081;
    console.log("localhost")
    return `http://localhost:${port}`;
  }
  return process.env.REACT_APP_API_BASE_URL;
};